import BaseStorage from './BaseStorage';

function parseCookies(str = document.cookie) {
    let cookies = new Map();
    str = (str || '').split(';');
    for (let c of str) {
        c = c.split('=');
        cookies.set(c.shift(), decodeURIComponent(c.join('=')));
    }
    return cookies;
}

function stringifyCookies(map) {
    let str = [];
    for (let [c, v] of map) {
        str.push(`${c}=${encodeURIComponent(v)}`);
    }
    return str.join(';');
}

/**
 * @class
 * @classdesc Хранение данных с помощью Cookie
 * @inheritDoc
 * @extends module:storage.BaseStorage
 * @memberOf module:storage
 */
class CookieStorage extends BaseStorage {

    constructor(key) {
        super(key);
    }

    get available() {
        return !!document;
    }

    get async() {
        return false;
    }

    load(callback = null) {
        let cookies = parseCookies(document.cookie);
        if (callback instanceof Function) {
            callback(cookies.get(this.key));
        }
        return cookies.get(this.key);
    }

    save(data, callback = null) {
        let cookies = parseCookies(document.cookie);
        cookies.set(this.key, data);
        document.cookie = stringifyCookies(cookies);
        if (callback instanceof Function) {
            callback();
        }
    }
}

export default CookieStorage;